import _ from '../../utils'

class PageTransitionLoaderClass {
    constructor() {
        this.DOM = {
            html: document.documentElement
        }
    }

    _loading() {
        _.addClass( this.DOM.html, 'is--transitioning' )
    }

    _loaded() {
        _.removeClass( this.DOM.html, 'is--transitioning' )
    }

}

const PAGE_TRANSITION_LOADER = new PageTransitionLoaderClass()
export default PAGE_TRANSITION_LOADER

